import React, { useState } from "react";
import EditMilestone from "./EditMilestone";
import DeletionModal from "./DeletionModal";
import EditGroup from "./EditGroup";
import { useDispatch } from "react-redux";

function TaskListOptions({
  milestone,
  data,
  setCurrentMilestone,
  groupTasks,
  setRenderer,
  renderer,
  currentMilestone,
  correspondingDetail,
  isButtonDisable,
}) {
  const dispatch = useDispatch();
  const [isMilestoneOptions, setIsMilestoneOptions] = useState(false);
  const [isGroupOptions, setIsGroupOptions] = useState(false);
  const [showEditMilestoneModal, setShowEditMilestoneModal] = useState(false);
  const [showDeletionModal, setShowDeletionModal] = useState(false);
  const [showEditGroupModal, setShowEditGroupModal] = useState(false);

  const groupObj = groupTasks?.group || groupTasks || {};
  const isGroupEditable = milestone ? true : (groupTasks ? (groupObj.is_editable !== undefined ? Boolean(groupObj.is_editable) : true) : true);
  const isGroupDeleteable = milestone ? true : (groupTasks ? (groupObj.is_deleteable !== undefined ? Boolean(groupObj.is_deleteable) : (groupObj.is_deletable !== undefined ? Boolean(groupObj.is_deletable) : true)) : true);

  const handleOptionsClick = () => {
    if (milestone) {
      setIsMilestoneOptions(!isMilestoneOptions);
      setIsGroupOptions(false);
    } else if (groupTasks) {
      setIsMilestoneOptions(!isMilestoneOptions);
      setIsGroupOptions(true);
    }
  };

  const handleEdit = () => {
    setIsMilestoneOptions(false);
    if (milestone) {
      setShowEditMilestoneModal(true);
    } else if (groupTasks && isGroupEditable) {
      setShowEditGroupModal(true);
    }
  };

  const currentMilestoneSelect = async (id) => {
    const responseData =
      await dispatch.projectDetails.projectMilestoneUpdataion({
        project_id: data?.project?.id,
        milestone_id: id,
        is_current_milestone: currentMilestone ? false : true,
      });

    if (responseData?.success === true) {
      setCurrentMilestone(id);
      setRenderer(!renderer);
      setIsMilestoneOptions(false);
    }
  };

  return (
    <div>
      <div className="flex justify-center">
        <div className="dropdown relative">
          {!isButtonDisable && (isGroupEditable || isGroupDeleteable) && (
            <button
              className="dropdown-toggle transition duration-150 ease-in-out flex items-center whitespace-nowrap"
              onClick={() => handleOptionsClick()}
              type="button"
              id="dropdownMenuButton1"
              data-bs-toggle="dropdown"
              aria-expanded={isMilestoneOptions}
            >
              <svg
                width="14"
                height="5"
                viewBox="0 0 14 5"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1.75 0.75C0.7875 0.75 0 1.5375 0 2.5C0 3.4625 0.7875 4.25 1.75 4.25C2.7125 4.25 3.5 3.4625 3.5 2.5C3.5 1.5375 2.7125 0.75 1.75 0.75ZM12.25 0.75C11.2875 0.75 10.5 1.5375 10.5 2.5C10.5 3.4625 11.2875 4.25 12.25 4.25C13.2125 4.25 14 3.4625 14 2.5C14 1.5375 13.2125 0.75 12.25 0.75ZM7 0.75C6.0375 0.75 5.25 1.5375 5.25 2.5C5.25 3.4625 6.0375 4.25 7 4.25C7.9625 4.25 8.75 3.4625 8.75 2.5C8.75 1.5375 7.9625 0.75 7 0.75Z"
                  fill="#8A8A82"
                />
              </svg>
            </button>
          )}

          {/* overlay only when open */}
          {isMilestoneOptions && (
            <div
              className="fixed inset-0 z-10"
              onClick={() => setIsMilestoneOptions(false)}
            ></div>
          )}

          {/* menu is always rendered so we can animate between states */}
          <ul
            className={
              "absolute bg-theme-paper text-base z-40 py-1 text-left rounded-theme-sm border border-theme-cream-3 shadow-theme-pop right-0 top-3 transition ease-out duration-300 " +
              (isMilestoneOptions
                ? "opacity-100 scale-100 translate-y-0 pointer-events-auto"
                : "opacity-0 scale-95 -translate-y-1 pointer-events-none")
            }
            aria-labelledby="dropdownMenuButton1"
          >
            {isGroupEditable && (
              <li>
                <button
                  className="text-sm py-2 px-4 pr-14 font-medium w-full whitespace-nowrap tracking-[0.20px] bg-transparent text-theme-fg-2 hover:bg-theme-cream-2 border-b border-theme-cream-3 flex items-center gap-3"
                  onClick={() => {
                    handleEdit();
                  }}
                  type="button"
                >
                  <svg
                    className="w-4 h-4"
                    viewBox="0 0 17 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16.71 4.0425L14.37 6.3725L10.62 2.6225L12.96 0.2925C13.35 -0.0975 14 -0.0975 14.37 0.2925L16.71 2.6325C17.1 3.0025 17.1 3.6525 16.71 4.0425ZM0 13.2525L10.06 3.1825L13.81 6.9325L3.75 17.0025H0V13.2525ZM13.62 1.0425L12.08 2.5825L14.42 4.9225L15.96 3.3825L13.62 1.0425ZM12.36 7.0025L10 4.6425L1 13.6625V16.0025H3.34L12.36 7.0025Z"
                      fill="#8A8A82"
                    />
                  </svg>
                  Edit
                </button>
              </li>
            )}

            {isGroupDeleteable && (
              <li>
                <button
                  className="text-sm py-2 px-4 pr-14 font-medium w-full whitespace-nowrap bg-transparent text-theme-full-fg hover:bg-theme-full-bg flex items-center gap-3 border-b border-theme-cream-3"
                  type="button"
                  onClick={() => {
                    setShowDeletionModal(true);
                    setIsMilestoneOptions(false);
                  }}
                >
                  <svg
                    width="17"
                    height="17"
                    viewBox="0 0 17 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16.0556 3.16602H0.944397M14.5738 5.38825L14.1649 11.5216C14.0076 13.8807 13.9294 15.0603 13.1605 15.7794C12.3916 16.4985 11.2085 16.4994 8.844 16.4994H8.15599C5.79153 16.4994 4.60842 16.4994 3.83952 15.7794C3.07063 15.0603 2.99152 13.8807 2.83507 11.5216L2.42618 5.38825"
                      stroke="#C53030"
                      stroke-linecap="round"
                    />
                    <path
                      d="M3.61108 3.16668H3.70886C4.06659 3.15754 4.41324 3.04066 4.70347 2.83131C4.99369 2.62197 5.21399 2.32991 5.33554 1.99334L5.36576 1.90179L5.45198 1.64312C5.52576 1.42178 5.56309 1.31156 5.61198 1.21734C5.70817 1.03279 5.84622 0.873327 6.01508 0.751698C6.18394 0.630069 6.37892 0.549654 6.58443 0.516889C6.68843 0.5 6.80488 0.5 7.03777 0.5H9.96223C10.1951 0.5 10.3116 0.5 10.4156 0.516889C10.6211 0.549654 10.8161 0.630069 10.9849 0.751698C11.1538 0.873327 11.2918 1.03279 11.388 1.21734C11.4369 1.31156 11.4742 1.42178 11.548 1.64312L11.6342 1.90179C11.7469 2.27625 11.9799 2.60313 12.2971 2.8318C12.6143 3.06047 12.998 3.17818 13.3889 3.16668"
                      stroke="#C53030"
                    />
                  </svg>
                  Delete
                </button>
              </li>
            )}

            {!isGroupOptions && (
              <li>
                <button
                  className="dropdown-item text-sm py-2 px-4  font-medium w-full whitespace-nowrap bg-transparent text-theme-fg-2 hover:bg-theme-cream-2 flex gap-2 "
                  type="button"
                  onClick={() => {
                    currentMilestoneSelect(milestone._id);
                  }}
                >
                  <svg
                    width="13"
                    height="16"
                    viewBox="0 0 13 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12.778 0.085C12.8462 0.130637 12.9022 0.192369 12.9409 0.264746C12.9796 0.337123 12.9999 0.417918 13 0.5V8C13 8.09985 12.9701 8.19741 12.9141 8.28011C12.8581 8.36281 12.7787 8.42685 12.686 8.464L12.683 8.465L12.677 8.468L12.654 8.477C12.5226 8.52934 12.3902 8.57934 12.257 8.627C11.993 8.722 11.626 8.85 11.21 8.977C10.394 9.229 9.331 9.5 8.5 9.5C7.653 9.5 6.952 9.22 6.342 8.975L6.314 8.965C5.68 8.71 5.14 8.5 4.5 8.5C3.8 8.5 2.862 8.73 2.063 8.977C1.70532 9.08869 1.35084 9.2104 1 9.342V15.5C1 15.6326 0.947321 15.7598 0.853553 15.8536C0.759785 15.9473 0.632608 16 0.5 16C0.367392 16 0.240215 15.9473 0.146447 15.8536C0.0526785 15.7598 0 15.6326 0 15.5V0.5C0 0.367392 0.0526785 0.240215 0.146447 0.146447C0.240215 0.0526784 0.367392 0 0.5 0C0.632608 0 0.759785 0.0526784 0.853553 0.146447C0.947321 0.240215 1 0.367392 1 0.5V0.782C1.226 0.703 1.496 0.612 1.79 0.522C2.606 0.272 3.67 0 4.5 0C5.34 0 6.024 0.277 6.621 0.519L6.664 0.537C7.286 0.788 7.828 1 8.5 1C9.2 1 10.138 0.77 10.937 0.523C11.3922 0.380471 11.8422 0.221702 12.286 0.047L12.305 0.04L12.309 0.038H12.31"
                      fill="#8A8A82"
                    />
                  </svg>
                  {currentMilestone
                    ? "Unmark as current milestone"
                    : "Mark as current milestone"}
                </button>
              </li>
            )}
          </ul>
        </div>
      </div>
      {showEditMilestoneModal && (
        <EditMilestone
          showEditMilestoneModal={showEditMilestoneModal}
          setShowEditMilestoneModal={setShowEditMilestoneModal}
          correspondingMilestone={milestone}
          setIsMilestoneOptions={setIsMilestoneOptions}
          setRenderer={setRenderer}
          renderer={renderer}
          correspondingDetail={correspondingDetail}
        />
      )}

      {showDeletionModal && (
        <DeletionModal
          deleteMilestone={milestone}
          deleteGroup={groupTasks}
          setShowDeletionModal={setShowDeletionModal}
          setRenderer={setRenderer}
          renderer={renderer}
        />
      )}
      {showEditGroupModal && (
        <EditGroup
          showEditGroupModal={showEditGroupModal}
          setShowEditGroupModal={setShowEditGroupModal}
          correspondingGroup={groupTasks}
          setRenderer={setRenderer}
          renderer={renderer}
        />
      )}
    </div>
  );
}

export default TaskListOptions;
